// extracted by mini-css-extract-plugin
export default {"title":"burger-ingredients-group_title__J6rio","cards":"burger-ingredients-group_cards__HRerz"};